import React, { useState } from 'react'
import styles from '@shared/components/Advertisement/Faq/Faq.module.scss'

const faq = [
  {
    query: 'What kind of advertising opportunities does your platform offer?',
    content: 'We offer a variety of advertising options including banner ads, sponsored content, product placements, and more.'
  },
  {
    query: 'Can advertisers target specific demographics or regions with their ads?',
    content:
      'Yes, we offer targeting options based on demographics, geography, interests, and more to ensure advertisers reach their desired audience effectively.'
  },
  {
    query: 'How can advertisers get started with advertising on your platform?',
    content:
      'Advertisers can get started by contacting our advertising team through the provided contact form on our website. Our team will assist with setting up campaigns, selecting targeting options, and optimizing ad creatives for maximum impact.'
  },
  {
    query: 'What is the pricing structure for advertising on your platform?',
    content:
      'Our pricing structure varies depending on the type of advertising, targeting options, and campaign duration. Advertisers can contact our team for customized pricing packages based on their specific needs and budget.'
  },
  {
    query: 'How do you ensure that advertisements on your platform are relevant and engaging for users?',
    content:
      'We carefully curate advertisements to ensure they are relevant and engaging for our audience. Additionally, we regularly monitor ad performance and optimize campaigns based on user feedback and engagement metrics to maximize effectiveness.'
  }
]
const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null)
  const handleClick = index => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return (
    <div className={styles.faqContainer}>
      <div className={styles.faqHead}>
        <h1 className={styles.faqH1}>Frequently Asked Questions</h1>
        <p className={styles.faqHeading}>We have compiled list of frequently asked questions to provide you with quick and comprehensive answers.</p>

      </div>
      {faq.map((data, i) => (
        <div key={i} className={`${styles.accordianItem} ${activeIndex === i ? styles.active : ''}`}>
          <div className={styles.accordionTitle} onClick={() => handleClick(i)}>
            <div>{data.query}</div>
            <div>{activeIndex === i ? '-' : '+'}</div>
          </div>
          {activeIndex === i && <div className={styles.accordianContent}>{data.content}</div>}
        </div>
      ))}
      <div className={styles.contactUs}>
        <p>More Questions?</p>
        <span className={styles.faqSpan}>
              <a target="_blank" href="mailto:hi@oneturf.news" rel="noreferrer">
                Contact us.
              </a>
            </span>
      </div>
    </div>

  )
}

export default Faq
